function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgEur = function SvgEur(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#0052B4"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256.001,100.174 264.29,125.683 291.11,125.683 269.411,141.448 277.7,166.957  256.001,151.191 234.301,166.957 242.59,141.448 220.891,125.683 247.712,125.683  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "145.814,145.814 169.714,157.99 188.679,139.026 184.482,165.516 208.381,177.693  181.89,181.889 177.694,208.381 165.517,184.482 139.027,188.679 157.992,169.714  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "100.175,256 125.684,247.711 125.684,220.89 141.448,242.59 166.958,234.301 151.191,256  166.958,277.699 141.448,269.411 125.684,291.11 125.684,264.289  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "145.814,366.186 157.991,342.286 139.027,323.321 165.518,327.519 177.693,303.62  181.89,330.111 208.38,334.307 184.484,346.484 188.679,372.974 169.714,354.009  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256.001,411.826 247.711,386.317 220.891,386.317 242.591,370.552 234.301,345.045  256.001,360.809 277.7,345.045 269.411,370.552 291.11,386.317 264.289,386.317  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "366.187,366.186 342.288,354.01 323.322,372.975 327.519,346.483 303.622,334.307  330.112,330.111 334.308,303.62 346.484,327.519 372.974,323.321 354.009,342.288  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "411.826,256 386.317,264.289 386.317,291.11 370.552,269.41 345.045,277.699 360.81,256  345.045,234.301 370.553,242.59 386.317,220.89 386.317,247.712  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "366.187,145.814 354.01,169.714 372.975,188.679 346.483,184.481 334.308,208.38  330.112,181.889 303.622,177.692 327.519,165.516 323.322,139.027 342.289,157.991  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEur, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EUR.7aea52bb.svg";
export { ForwardRef as ReactComponent };